import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import { getByDocCreator } from '../../shared/getByDocCreator';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';

import { PdpRespTitle_item$key } from './__generated__/PdpRespTitle_item.graphql';

import styles from './PdpRespTitle.scss';

type Props = {
    item: PdpRespTitle_item$key;
    reduceSize?: boolean;
};

export const PdpRespTitle: FC<Props> = ({ item: itemRef, reduceSize }) => {
    const item = useFragment(
        graphql`
            fragment PdpRespTitle_item on Item {
                title
                isArt
                classification {
                    creationDate
                }
                ...getByDocCreator_item
            }
        `,
        itemRef
    );
    const { isArt, title, classification } = item || {};

    let artCreator = null;
    let artCreationDate = null;
    const [state] = useItemTranslations();
    let itemTitle: string | ReactNode =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.title
            : title;

    if (isArt) {
        itemTitle = (
            <span className={styles.artTitle} data-tn="pdp-item-title">
                {itemTitle}
            </span>
        );

        const creationDate = classification?.creationDate;
        if (creationDate) {
            artCreationDate = (
                <p
                    className={classnames(styles.artCreationDate, {
                        [styles.reduceSize]: reduceSize,
                    })}
                    data-tn="pdp-item-creation-date"
                >
                    {creationDate}
                </p>
            );
        }

        artCreator = getByDocCreator({ item });
    }

    return (
        <h1
            className={classnames(styles.wrapper, { [styles.reduceSize]: reduceSize })}
            data-tn="pdp-resp-title"
        >
            {artCreator}
            <div data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
};
